import './ColorSwatch.css'

interface ColorSwatchProps {
  hex: string
  name: string
  active: boolean
  onClick: () => void
}

export function ColorSwatch({ hex, name, active, onClick }: ColorSwatchProps) {
  return (
    <button
      type="button"
      className={`color-swatch${active ? ' is-active' : ''}`}
      style={{ backgroundColor: hex }}
      onClick={onClick}
      aria-label={name}
      aria-pressed={active}
    >
      {hex.toLowerCase() === '#ffffff' && <span className="color-swatch-outline" />}
    </button>
  )
}
